import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import ServicesHero from '@/pages/services/components/ServicesHero';
import OfferingsGrid from '@/pages/services/components/OfferingsGrid';
import IbmPartnerSection from '@/pages/services/components/IbmPartnerSection';
import ProcessSection from '@/pages/services/components/ProcessSection';
import ServicesCta from '@/pages/services/components/ServicesCta';

export default function Services() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <SiteNavbar />
      <main>
        <ServicesHero />
        <OfferingsGrid />
        <IbmPartnerSection />
        <ProcessSection />
        <ServicesCta />
      </main>
      <SiteFooter />
    </div>
  );
}